<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Tipo Documento</mat-label>
      <mat-select formControlName="typeDocument">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <div class="mt-message-input w-5/12">
      <input
        hidden
        type="file"
        (change)="onFileSelected($event)"
        #fileInput
        [accept]="getAllowedTypes()"
      />
      <!--        accept=".xlsx,.application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"-->
      <mat-form-field
        class="input-tg input-btn-icon w-full"
        appearance="outline"
      >
        <mat-label>Arquivo</mat-label>
        <input matInput formControlName="file" readonly />
        <button mat-icon-button matSuffix (click)="fileInput.click()">
          <mat-icon>upload</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editFile()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createFile()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
